import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";

export const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const titles = {
      "/": "The Scent Butler | Commercial Scenting Collection",
      "/shop": "Shop | The Scent Butler",
      "/commercial-scenting": "Commercial Scenting for Business | The Scent Butler",
      "/cart": "Your Bag | The Scent Butler",
      "/checkout": "Checkout | The Scent Butler",
      "/account": "Your Account | The Scent Butler",
      "/info": "Our Promise & Commitment | The Scent Butler",
      "/enquiries": "Business Scenting Enquiries | The Scent Butler",
      "/privacy": "Privacy Policy | The Scent Butler",
      "/terms": "Terms & Conditions | The Scent Butler",
      "/admin": "Admin Dashboard | The Scent Butler",
    };
    document.title = titles[pathname] || "The Scent Butler | Luxury Commercial Scenting";
  }, [pathname]);

  const isAdmin = pathname === "/admin";

  return (
    <div className="App grain min-h-screen">
      {!isAdmin && <Navbar />}
      <main>
        <Outlet />
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
};
